/* Customer Reviews HH — stagger fade-in + auto carousel (RTL-safe) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fadeIn(sec) {
    var cards = sec.querySelectorAll('.hh-reviews__card');
    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = Array.prototype.indexOf.call(cards, entry.target);
          entry.target.style.transitionDelay = (idx % 6) * 80 + 'ms';
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    cards.forEach(function (c) { io.observe(c); });
  }

  function autoplay(sec) {
    if (reduceMotion) return;
    var grid = sec.querySelector('.hh-reviews__grid');
    if (!grid || grid.dataset.hhAuto === '1') return;
    if (grid.children.length <= 1) return;
    grid.dataset.hhAuto = '1';

    // Mandatory scroll-snap snaps programmatic scrolls back; disable so autoplay moves freely.
    grid.style.scrollSnapType = 'none';

    var speed = parseInt(sec.dataset.speed, 10) || 3000;

    // Robust RTL direction detection: probe both directions, keep whichever actually moves.
    var prevBehavior = grid.style.scrollBehavior;
    grid.style.scrollBehavior = 'auto';
    grid.scrollLeft = 0; grid.scrollLeft = -50; var negMove = grid.scrollLeft;
    grid.scrollLeft = 0; grid.scrollLeft = 50; var posMove = grid.scrollLeft;
    grid.scrollLeft = 0;
    grid.style.scrollBehavior = prevBehavior;
    var dir = (negMove < -1) ? -1 : ((posMove > 1) ? 1 : -1);

    var pos = 0;
    var timer = null;

    function go() {
      var max = grid.scrollWidth - grid.clientWidth;
      if (max <= 0) return;
      var first = grid.children[0];
      var step = (first ? first.getBoundingClientRect().width : grid.clientWidth) + 24;
      pos += step;
      if (pos > max - 4) pos = 0;
      grid.scrollTo({ left: dir * pos, behavior: 'smooth' });
    }
    function start() { if (!timer && !document.hidden) timer = window.setInterval(go, speed); }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

    start();

    ['mouseenter', 'pointerdown', 'touchstart', 'focusin'].forEach(function (ev) {
      grid.addEventListener(ev, stop, { passive: true });
    });
    ['mouseleave', 'touchend', 'focusout'].forEach(function (ev) {
      grid.addEventListener(ev, function () { window.setTimeout(start, 1200); }, { passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
  }

  function init() {
    document.querySelectorAll('.hh-reviews').forEach(function (sec) {
      fadeIn(sec);
      autoplay(sec);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
